export const projectedAmount = [
    "Tier-1 Less than $30,000",
    "Tier-2 $30,000 - $100,000",
    "Tier-3 Greater than $100,000"
]

export const projectedFrequency = [
    "Tier-1 Less than 5 times",
    "Tier-2 5-10 Times",
    "Tier-3 Greater than 10 Times"
]